import { TLC_CONSTANTS } from "../../../../../../js/lib/tlc-constants";
import { TLCEventManager } from "../../../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../../../js/main/constants";
import { ApplicationData } from "../../../ApplicationData";
import { FinesClientManager } from "../../../ClientManagers/FinesClientManager";
import { SuccessMessageControl } from "../../../controls/successMessageControl";
import { LS2PAC_Utils } from "../../../utils/Utils";
import { MyAccountBaseSubView } from "../BaseSubView";
import { convertPenniesToCurrency } from "@tlc/ls2pac/components/AccountMenu";
import { PrintAccountDataEvent } from "@tlc/ls2pac/app/managers/PrintAccountDataManager";

export class FinesView extends MyAccountBaseSubView {
  constructor(options) {
    options = options || {};
    options.template = "tmpl/myAccount/accountActivity/fines.html";
    options.itemsTemplate = "tmpl/myAccount/accountActivity/finesItems.html";
    options.viewName = LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.fines;
    options.id = options.viewName;
    options.countField = "feesInCurrency";
    options.dataFieldName = "fees";
    options.tabText =
      ApplicationData.language.fines +
      ' <span id="' +
      options.id +
      '_tab_count"></span>';
    options.addBookJackets = false;

    options.sortOptions = [
      {
        sortValue: "OutDate",
        sortText:
          ApplicationData.language.sortBy + " " + ApplicationData.language.date,
      },
      {
        sortValue: "Title",
        sortText:
          ApplicationData.language.sortBy +
          " " +
          ApplicationData.language.title,
      },
      {
        sortValue: "Author",
        sortText:
          ApplicationData.language.sortBy +
          " " +
          ApplicationData.language.author,
      },
    ];

    super(options);
  }
  getClientManager(){
    return FinesClientManager.getInstance({
      resultsPanelId: this.id,
    });
  }
  fetchData() {
    var paySelectedButton = $("#" + this.id).find(".paySelected");
    if (!ApplicationData.locationConfiguration.getCarlXWebEcommerceEnabled()) {
      paySelectedButton.prop("disabled", true);
      paySelectedButton.addClass(TLC_CONSTANTS.CssClasses.disabled);
      //if carl is off and ls is off, then remove the button altogether
      if (ApplicationData.locationConfiguration.isEcommerceEnabled() == false) {
        paySelectedButton.hide();
      }
    } else {
      paySelectedButton.prop("disabled", false);
      paySelectedButton.removeClass(LS2PAC_CONSTANTS.CssClasses.toggleButton);
      paySelectedButton.removeClass(TLC_CONSTANTS.CssClasses.disabled);
      paySelectedButton.parent().addClass("noBorder");
    }
    TLCEventManager.fireEvent(this.clientManager.searchEvent);
  }
  addEvents() {
    var _this = this;
    this.addEventHandler($("#" + this.id), "click", ".payFine, .paySelected", (event) => {
      $(event.currentTarget).addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
      $(event.currentTarget).prop("disabled", true);
      this.payFines(this.getSelectedItems());
      return false;
    });
    this.addEventHandler($("#" + this.id), "click", ".printMyAccountData", () => {
      TLCEventManager.fireEvent(
        PrintAccountDataEvent,
        { sections: [LS2PAC_CONSTANTS.MyAccountPrintTypes.fines] }
      );
      return false;
    });
  }
  setSideTabCount() {
    $("#" + LS2PAC_CONSTANTS.Ids.MyAccountPage.totalFines)
      .text(convertPenniesToCurrency(this.accountSummary.patron.fees));
  }
  payFines(fines) {
    var baseUrl =
        ApplicationData.locationConfiguration.getCarlXWebEcommerceEnabled()
          ? ApplicationData.locationConfiguration.getCarlXWebEcommerceUrl()
          : "ecommerce/start?",
      currentUrl = window.location.href,
      QSIndex = currentUrl.indexOf("?"),
      fineArgs = [];

    //if its LS
    if (!ApplicationData.locationConfiguration.getCarlXWebEcommerceEnabled()) {
      if (QSIndex !== -1) {
        //strip out the query string so we can send it to the pop up
        var queryString = currentUrl.substring(QSIndex + 1);
        var hashIndex = queryString.indexOf("#");
        if (hashIndex !== -1) {
          queryString = queryString.substring(0, hashIndex);
        }
        baseUrl += queryString + "&";
      }
      TLCLogger.log("fines", fines);
      $.each(fines, function (index, fine) {
        fineArgs.push(
          fine.chargeNumber + "," + fine.feeInCurrency + "," + fine.fee
        );
      });
      baseUrl += "fines=" + fineArgs.join("|");
    }

    try {
      //i have no idea what this does or why its useful
      document.domain = window.location.hostname.rootDomain();
      //changed width and height of window depending if its carl or ls
      const ecommerceWindow = window.open(
        baseUrl,
        "ecommerceWindow",
        "location=0,status=1,scrollbars=1,resize=0," +
          (ApplicationData.locationConfiguration.getCarlXWebEcommerceEnabled()
            ? "width=770,height=640"
            : "width=640,height=640")
      );
      ecommerceWindow.moveTo(40, 40);
    } catch (e) {
      TLCLogger.log("surpressed error opening payment window", e);
    }
  }
  manipulateData() {
    var data = this.pageData[this.dataFieldName];
    $.each(data, function (index, fine) {
      fine.feeInCurrency = LS2PAC_Utils.convertPenniesToCurrency(fine.fee);
      fine.outDateString = LS2PAC_Utils.getDateString(fine.outDate);
    });
  }
  addListeners() {
    this.addListener(LS2PAC_CONSTANTS.Events.onFinePaymentUpdate, () => {
      this.updateAccountData();
    });
  }
}

// TODO why are we extending String's prototype?
window.String.prototype.rootDomain = function () {
  var ipRegex = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
  if (this.toString().match(ipRegex)) {
    return this.toString();
  }
  var numberOfPeriods = (this.toString().match(/\./g) || []).length;
  if (numberOfPeriods > 1) {
    return this.substring(this.indexOf(".") + 1);
  }
  return this.toString();
};

window.popupWindowCallBack = function (
  authorizeSuccess,
  lsUpdateSuccess,
  invoiceNumber,
  responseText
) {
  if (authorizeSuccess && lsUpdateSuccess) {
    TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onFinePaymentUpdate, {});
    setTimeout(function () {
      SuccessMessageControl.show(ApplicationData.language.finesPaymentSuccess);
    }, 500);
  }
};
